import { createFileRoute } from '@tanstack/react-router';
import { Swords } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';

export const Route = createFileRoute('/_student/contests/')({ component: ContestsPage });

function ContestsPage() {
  return (
    <div className="mx-auto max-w-[1200px] p-6">
      <EmptyState icon={Swords} title="Contests are on the way"
        description="Timed coding contests will appear here soon." />
    </div>
  );
}
